// Reviews are ANONYMOUS (owner decision 2026-09-28). A trader's name and
// company never appear on a review — not to the supplier reviewed, not to
// other traders on the public profile, not even after acceptance. Every review
// is attributed to the same neutral label, on every screen that shows one.
//
// Reads go through supplier_reviews_public, a view with no reviewer_id and no
// request_id (supabase/migrations/20260929005700_reviews_anonymous.sql). Raw `reviews` rows are
// readable by their author and admins only once that SQL is applied.
//
// WORKS IN EITHER DEPLOY ORDER. Before the SQL is applied the view does not
// exist: the read fails and this falls back to the raw table — still open at
// that point — and DROPS reviewer_id / request_id from every row before any
// caller sees it, so no screen can attach a name to a review either way.
//
// Mirrored in maabar-app src/lib/supplierReviews.js.

export const REVIEWER_LABEL = {
  ar: 'مشترٍ موثّق عبر مَعبر',
  en: 'Maabar verified buyer',
  zh: '经 Maabar 认证的采购商',
};

export const reviewerLabel = (lang) => REVIEWER_LABEL[lang] || REVIEWER_LABEL.en;

const IDENTITY_KEYS = ['reviewer_id', 'request_id', 'buyer_id'];

export const anonymizeReview = (row) => {
  if (!row) return row;
  const out = { ...row };
  for (const k of IDENTITY_KEYS) delete out[k];
  return out;
};

export async function fetchSupplierReviews(sb, supplierId) {
  if (!supplierId) return [];
  const view = await sb.from('supplier_reviews_public')
    .select('*').eq('supplier_id', supplierId).order('created_at', { ascending: false });
  if (!view.error) return view.data || [];
  // Expected before the SQL is applied (relation does not exist).
  console.error('[supplierReviews] view read failed, falling back:', view.error.code || '', view.error.message || view.error);
  const raw = await sb.from('reviews')
    .select('*').eq('supplier_id', supplierId).order('created_at', { ascending: false });
  if (raw.error) {
    console.error('[supplierReviews] reviews read failed:', raw.error.code || '', raw.error.message || raw.error);
    return [];
  }
  return (raw.data || []).map(anonymizeReview);
}
